import { makeStyles } from '@material-ui/core'

const connectPageStyles = makeStyles((theme) => {
    const mobileBreakpoint = theme.breakpoints.down('sm')
    return {
        connectPageContent: {
            width: '100%',
            maxWidth: '1441px',
            marginLeft: 'auto',
            marginRight: 'auto',
            paddingLeft: '88px',
            paddingRight: '88px',
            boxSizing: 'border-box'
        },
        secondaryContent: {
            alignSelf: 'stretch',
            margin: 0,
            color: 'var(--neutrals-grey-900, #212121)',
            fontFamily: 'Roboto',
            fontSize: '20px',
            fontStyle: 'normal',
            fontWeight: 500,
            lineHeight: '28px',
            [mobileBreakpoint]: {
                fontSize: '1.25rem'
            }
        },
        whatToExpect: {
            alignSelf: 'stretch',
            width: '100%',
            margin: 0,
            color: 'var(--neutrals-grey-900, #212121)',
            fontFamily: 'Roboto',
            fontSize: '16px',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: '22px',
            [mobileBreakpoint]: {
                margin: 'auto',
                padding: '1rem 0px'
            }
        },
        bannerTitle: {
            alignSelf: 'stretch',
            margin: 0,
            color: 'var(--neutrals-grey-900, #212121)',
            fontFamily: 'Roboto',
            fontSize: '42px',
            fontStyle: 'normal',
            fontWeight: 700,
            lineHeight: '58px',
            [mobileBreakpoint]: {
                paddingBottom: '1rem',
                fontSize: '2rem'
            }
        },
        continueBtn: {
            display: 'flex',
            background: '#007DB8 !important',
            borderRadius: '0.25rem',
            fontWeight: 500,
            fontSize: '0.875rem',
            lineHeight: '1.875rem',
            fontFamily: 'var(--font-family-bold)',
            textTransform: 'capitalize',
            color: 'var(--white) !important',
            width: '100%',
            height: '42px',
            padding: '8px',
            margin: 0,
            alignItems: 'center',
            alignSelf: 'stretch',
            '&[disabled]': {
                color: 'var(--white) !important',
                backgroundColor: 'var(--disabled) !important'
            }
        },
        flexBox: {
            display: 'flex',
            width: '100%',
            minHeight: '478px',
            paddingTop: '24px',
            paddingBottom: '24px',
            justifyContent: 'space-between',
            alignItems: 'center',
            alignContent: 'center',
            flexWrap: 'wrap',
            position: 'relative',
            boxSizing: 'border-box',
            [mobileBreakpoint]: {
                display: 'block',
                margin: 'auto',
                paddingRight: '0px',
                paddingTop: '0px'
            }
        },
        rightBox: {
            width: '474px',
            flexShrink: 0,
            [mobileBreakpoint]: {
                display: 'block',
                paddingRight: '0px',
                paddingLeft: '0px'
            }
        },
        rightInnerBox: {
            [mobileBreakpoint]: {
                width: '100%',
                height: 'auto'
            }
        },
        leftBox: {
            display: 'flex',
            width: '604px',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '26px',
            flexShrink: 0,
            [mobileBreakpoint]: {
                display: 'block',
                marginRight: '0px',
                marginLeft: '0px',
                gap: '0px',
                width: '100%',
                height: 'auto'
            }
        },
        accountingProviders: {
            display: 'flex',
            width: '100%',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '16px',
            boxSizing: 'border-box'
        },

        emailForm: {
            display: 'flex',
            width: '100%',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '24px'
        },
        emailFields: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '8px',
            alignSelf: 'stretch'
        },
        emailHeading: {
            alignSelf: 'stretch',
            margin: 0,
            color: 'var(--neutrals-grey-900, #212121)',
            fontFamily: 'Roboto',
            fontSize: '24px',
            fontStyle: 'normal',
            fontWeight: 500,
            lineHeight: '34px',
            overflowWrap: 'break-word'
        },

        emailInput: {
            display: 'flex',
            width: '100%',
            height: '64px',
            paddingTop: '16px',
            justifyContent: 'center',
            alignItems: 'center',
            alignSelf: 'stretch',
            boxSizing: 'border-box'
        },

        btn_primary: {
            color: 'var(--white)',
            backgroundColor: 'var(--teal-blue)',
            '&:hover': {
                color: 'var(--white)',
                backgroundColor: 'var(--teal-blue)'
            }
        },
        applicationText: {
            [mobileBreakpoint]: {
                fontSize: '1.25rem !important'
            }
        },
        faqContainer: {
            boxShadow: '0px 2px 4px 0px #0000000D',
            borderRadius: '4px',
            backgroundColor: 'var(--white)',
            marginTop: '40px',
            position: 'relative'
        },
        companyLogo: {
            display: 'flex',
            alignItems: 'flex-start',
            gap: '26px',
            width: 'fit-content'
        },
        howDoesItWorkContainer: {
            display: 'flex',
            width: '100%',
            paddingTop: '12px',
            paddingBottom: '12px',
            justifyContent: 'space-between',
            alignItems: 'center',
            boxSizing: 'border-box',
            position: 'relative',
            borderRadius: '4px',
            background: 'var(--neutrals-grey-00, #FFF)',
            boxShadow: '0 4px 5px 0 rgba(0, 0, 0, 0.05), 0 1px 10px 0 rgba(0, 0, 0, 0.05), 0 2px 4px 0 rgba(0, 0, 0, 0.05)'
        },
        howDoesItWorkContentContainer: {
            display: 'flex',
            minWidth: '435px',
            padding: '56px',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'flex-start',
            gap: '40px',
            flex: '1 0 0',
            boxSizing: 'border-box',
            background: 'var(--neutrals-grey-00, #FFF)'
        },
        howDoesItWorkTitle: {
            alignSelf: 'stretch',
            margin: 0,
            color: 'var(--neutrals-grey-900, #212121)',
            fontFamily: 'Roboto',
            fontSize: '30px',
            fontStyle: 'normal',
            fontWeight: 500,
            lineHeight: '42px'
        },
        howDoesItWorkDetails: {
            display: 'flex',
            width: '100%',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '32px',
            alignSelf: 'stretch'
        },
        howDoesItWorkImage: {
            display: 'block',
            width: '100%',
            height: '100%'
        },
        stepsContainer: {
            display: 'flex',
            width: '100%',
            alignItems: 'flex-start',
            gap: '16px',
            alignSelf: 'stretch'
        },
        stepCount: {
            display: 'flex',
            width: '32px',
            height: '32px',
            padding: '8px',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '8px',
            flex: '0 0 32px',
            boxSizing: 'border-box',
            borderRadius: '72px',
            background: 'var(--grey-200, #E3E3E3)',
            color: 'var(--grey-900, #3A3A3A)',
            fontFamily: 'Roboto',
            fontSize: '16px',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: '22px'
        },
        stepsList: {
            display: 'flex',
            width: '100%',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '24px',
            alignSelf: 'stretch'
        },
        stepText: {
            flex: '1 0 0',
            margin: 0,
            color: 'var(--grey-900, #3A3A3A)',
            fontFamily: 'Roboto',
            fontSize: '16px',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: '22px'
        },
        getStartedBtn: {
            display: 'flex',
            width: '245px !important',
            height: '42px',
            padding: '8px',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '8px',
            margin: 0,
            boxSizing: 'border-box',
            borderRadius: '4px',
            background: '#007DB8 !important',
            color: 'var(--neutrals-grey-00, #FFF) !important',
            textAlign: 'center',
            fontFamily: 'Roboto',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: 500,
            lineHeight: '20px',
            textTransform: 'none'
        },
        howDoesItWorkGraphic: {
            width: '620px',
            height: '557px',
            flexShrink: 0,
            boxSizing: 'border-box',
            background: 'var(--neutrals-grey-00, #FFF)'
        },
        providerLogo: {
            display: 'block',
            width: '40px',
            height: '40px',
            flexShrink: 0
        },
        netSuiteLogo: {
            display: 'flex',
            borderRadius: '55.346px',
            background: '#FFF',
            justifyContent: 'center',
            alignItems: 'center'
        },
        root: {
            backgroundAttachment: 'fixed'
        },
        trapezoidBg: {
            position: 'relative',
            zIndex: 1,
            '&::before': {
                content: '""',
                background: 'linear-gradient(234deg, #005C82 28.58%, #0B9EDB 99.46%)',
                position: 'fixed',
                top: '0',
                left: '0',
                width: '100%',
                height: '100%',
                clipPath: 'polygon(92% 0, 100% 0, 100% 100%, 44.5% 100%)'
            }
        }
    }
})

export default connectPageStyles
